// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3A5ER","actions":"GroupTable_actions__27GUy","deleteModalFooter":"GroupTable_deleteModalFooter__3QFGZ"};